export const GET_CATEGORIES_MARKETPLACE = "GET_CATEGORIES_MARKETPLACE";
export const GET_CATEGORIES_BENEFITS_MARKETPLACE = "GET_CATEGORIES_BENEFITS_MARKETPLACE";
export const GET_CATEGORY_TYPE_MARKETPLACE = "GET_CATEGORY_TYPE_MARKETPLACE";
export const GET_SUBCATEGORIES_MARKETPLACE = "GET_SUBCATEGORIES_MARKETPLACE"; 
export const GET_STATE_LOADING_MARKETPLACE = "GET_STATE_LOADING_MARKETPLACE";
export const GET_MODO_MARKETPLACE = "GET_MODO_MARKETPLACE";
export const GET_CATEGORIES_ID_MARKETPLACE = "GET_CATEGORIES_ID_MARKETPLACE";

